import PromotionContainerBlock from './PromotionContainerBlock'
import PromotionContainerCardBlock from './PromotionContainerCardBlock'

export { PromotionContainerBlock, PromotionContainerCardBlock }
